/* ================================================== */
/* CAROUSEL
/* ================================================== */

$(document).ready(function() {
	$('.carousel').each(function(index, element) {
		var hammerState = null;

		function step(element, n) {
			setTimeout(function() {
				// Init
				if (n === -1) n = $('.carousel-item', element).length - 1;
				if (n === $('.carousel-item', element).length) n = 0;

				// Update selected
				$('.is-selected', element).removeClass('is-selected');
				$('.carousel-item', element).eq(n).addClass('is-selected');
				$('.carousel-indicator', element).eq(n).addClass('is-selected');

				// Accessibility
				var $prev = $('.sr-only .carousel-button-prev', element),
					$next = $('.sr-only .carousel-button-next', element);
				if ($prev.length) $prev.html($prev.attr('data-label').replace('{n}', (n === 0) ? $('.carousel-item', element).length : n));
				if ($next.length) $next.html($next.attr('data-label').replace('{n}', (n + 2 > $('.carousel-item', element).length) ? 1 : n + 2));

				$('.carousel-item:not(.is-selected), .carousel-item:not(.is-selected) .carousel-button[tabindex="0"]', element).each(function(index, element) {
					$(element).attr('tabindex', '-1');
				});
				$('.carousel-item.is-selected, .carousel-item.is-selected .carousel-button[tabindex="-1"]', element).each(function(index, element) {
					$(element).attr('tabindex', '0');
				});
			}, 300);

			setTimeout(function() {
				$('.slides-layout', element).removeClass('transitioning').attr('data-slide-index', n+1);
			}, 900);
		}

		function prev(element, play) {
			step($(element), $('.carousel-item.is-selected', element).index() - 1);
			play = play || true;
		}

		function next(element, play) {
			step($(element), $('.carousel-item.is-selected', element).index() + 1);
		}

		// Prev
		$('.carousel-button-prev', element).click(function(event) {
			event.preventDefault();
			prev($(element));
		});

		$('.carousel-wrapper:not([data-total="1"]) .carousel-link', element)
		.hammer({ direction: Hammer.DIRECTION_RIGHT }).bind('swiperight', function(event) {
			hammerState = event.type;
			prev($(element));
		});

		// Next
		$('.carousel-button-next', element).click(function(event) {
			event.preventDefault();
			next($(element));
		});

		$('.carousel-wrapper:not([data-total="1"]) .carousel-link', element)
		.hammer({ direction: Hammer.DIRECTION_LEFT }).bind('swipeleft', function(event) {
			hammerState = event.type;
			next($(element));
		});

		$('.carousel-wrapper:not([data-total="1"]) .carousel-link', element).click(function(event) {
			if (hammerState != null) event.preventDefault();
			hammerState = null;
		});

		// To n
		$('[data-slide-to]', element).click(function() {
			if (!$('.carousel-item', element).eq($(this).data('slide-to')).hasClass('is-selected')) {
				step($(element), $(this).data('slide-to'));
			}
		});

		// Keyboard controls
		$(element).on('keyup', function(event) {
			if ([37, 39].indexOf(event.keyCode) > -1) event.preventDefault();
			if (event.keyCode === 37) prev($(this));
			if (event.keyCode === 39) next($(this));
		});

		$('.carousel-nav-link', element).on('keyup', function(event) {
			if (event.keyCode === 13) {
				step($(element), $(':focus').data('slide-to'));
			}
		});
	});
});